export class AppConstants {
    public static API_ENDPOINT = 'https://app.consultorio.live/';
    //public static API_ENDPOINT = 'http://localhost:3000/';
    public static RES_ENDPOINT = 'https://vbbconsultoriolive.com/';
 }
